import { z } from 'zod';

export const EquipmentItemListSearchSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().default(100),
  sortColumn: z
    .enum([
      'NAME',
      'DESCRIPTION',
      'ITEM_TYPE',
      'ASSIGNED_OR_PLACED',
      'AVAILABLE',
      'TOTAL',
    ])
    .optional(),
  orderDirection: z.enum(['asc', 'desc']).default('asc'),
  freeText: z.string().optional(),
  equipmentTypeId: z.string().optional(),
});

export type EquipmentItemListSearch = z.infer<
  typeof EquipmentItemListSearchSchema
>;
